module.exports = __webpack_public_path__ + "img/profileLogoFLIT2go.3e3ecc9c.png";